import { Box, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// "Working month" on every threshold screen. The list below shows what applies from this month onward, and every change
// you make starts here (the form's "Applies from" can still be changed). It is the same month as on the results pages
// and the landing page - pick it anywhere and it follows you.
//
// Why it is here: the list used to show only what applies NOW, so a threshold that had been switched off from October
// looked "off" even while May - the month being looked at - still used it, and there was nothing to click that could
// change May. Now the list is for the month you are working in.
const WorkingMonthBar = ({ month, setMonth }) => (
  <Box display="flex" alignItems="center" gap={2} flexWrap="wrap" sx={{ mb: 2 }}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        views={['year', 'month']}
        label="Working month"
        value={month}
        onChange={(value) => value && value.isValid() && setMonth(value)}
        slotProps={{ textField: { size: 'small', sx: { width: 190 } } }}
      />
    </LocalizationProvider>
    <Typography variant="body2" color="text.secondary" sx={{ flex: 1, minWidth: 240 }}>
      Showing what applies from {month.format('MMMM YYYY')} onward. Changes you save here start in {month.format('MMMM YYYY')}
      {' '}(you can change that in the form).
    </Typography>
  </Box>
);

export default WorkingMonthBar;
